module.exports = __webpack_public_path__ + "static/media/blog-hai-banner.edf09e80.jpg";